<template>
    <LegacyReader />
</template>

<script setup lang="ts">
import LegacyReader from '~/components/pupil/LegacyReader.vue';

definePage({
    meta: {
        area: 'reader',
    },
});
</script>
